// extracted by mini-css-extract-plugin
export var accordion = "_dq-0";
export var chevron = "_dq-3";
export var closed = "_dq-2";
export var content = "_dq-4";
export var open = "_dq-1";
export var rotate = "_dq-5";